/**
 * App-wide PrimeVue pass-through, merged after each component's own
 * attributes.
 */
export default {
  button: {
    // Button disables itself while `loading`, but a passed `:disabled` is
    // merged after that and wins, so `:loading="saving" :disabled="!valid"`
    // stayed clickable mid-request. `context.disabled` is Button's own
    // "disabled or loading"; applying it here restores busy = disabled.
    root: ({ props, context }: { props: { as?: string }, context: { disabled?: boolean } }) =>
      props.as === 'BUTTON' && context.disabled ? { disabled: true } : {},
  },
  select: {
    // A Select's focusable element is a <span role="combobox">, which a
    // <label for> can't name, so screen readers heard its value ("United
    // States") instead of "Country". KbField gives its label the id
    // `${fieldId}-label`; a Select with that input-id is labelled by it.
    // Without such a label the reference is ignored and the value is read
    // as before. An explicit aria-label / aria-labelledby wins.
    label: ({ props }: { props: { inputId?: string, editable?: boolean, ariaLabel?: string, ariaLabelledby?: string } }) =>
      props.inputId && !props.editable && !props.ariaLabel && !props.ariaLabelledby
        ? { 'aria-labelledby': `${props.inputId}-label` }
        : {},
  },
}
